<template>
  <va-show-layout>
    <va-show :item="item">
      <v-row justify="center">
        <v-col sm="6">
          <base-material-card>
            <template v-slot:heading>
              <div class="display-2">
                {{ title }}
              </div>
            </template>
            <v-card-text>
              <va-field source="name" ></va-field>
              <va-field source="dns" ></va-field>
              <va-field source="inspectionHours" type="number" ></va-field>
              <va-field source="horimetre" type="number" ></va-field>
              <va-field source="modelo_id" type="select" ></va-field>
            </v-card-text>
          </base-material-card>
        </v-col>
      </v-row>
    </va-show>
  </va-show-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
